import React from "react";

interface NavbarProps {
  list: {
    key: any;
    component: any;
    grid?: boolean;
  }[];
  active: any;
  className?: string;
}

/**
 * Yeni nesil sekme içeriği: yalnız aktif sekme render edilir (temiz, çakışmasız).
 */
const CustomTabContent = ({ list, active }: NavbarProps) => {
  const current = list.find((x) => x.key === active);
  if (!current) return null;
  return <div className="m-tabpane">{current.component}</div>;
};
export default CustomTabContent;
